import React from 'react'
import './../../App.css'
import moment from 'moment'
// import {Link} from 'react-router-dom'


const New = (props) =>{
    const  { result } = props
    return (
        <React.Fragment>
            <div className="col-sm-12 col-md-6">
                < div className = "card mb-4 shadow-sm news-card" >

                    <div className = "card-body" >
                        <div className="row">                          
                             <div className="col-sm-6 col-md-7">          
                                <div className="card-text">
                                     <h5 className="new-body">{result.title}</h5>
                                    <p><small><em>published:</em> {moment(result.publishedAt).format('LLLL')}</small></p>
                                         <p><a href={result.url} rel="noopener noreferrer" target="_blank" >Read more</a></p> 
                                    {/* <Link to ={`news/new?=${aid}`}>
                                        Read more
                                        </Link> */}
                                </div>
                             </div>
                                < div className = "col-sm-6 col-md-5 news">
                                    <img src={result.urlToImage}  alt="technews worldwide news"/>
                                    
                                </div>                            
                        </div>                      
                    </div>
                </div>
            </div>
        </React.Fragment>
    )
}

export default New